module.exports = __webpack_public_path__ + "img/zj.28ff83ee.jpg";